import { getDeviceSetting, setDeviceSetting, deviceSettingEvent } from '../utils/device_settings';

// Apply the "show_stage" setting: hide the environment banner on this device when it is turned off.
// The banner is server-rendered only outside production, so this compiler is a no-op there.
up.compiler('#env-banner', (banner) => {
  // Drive everything from one class on <html>: hiding the banner alone would leave the 20px the
  // layout reserves for it (the `banner-space` offsets) as empty space, so the CSS also collapses
  // those, making the device render full-height exactly like production.
  const apply = () => {
    document.documentElement.classList.toggle('stage-hidden', getDeviceSetting('show_stage', true) === false);
  };
  apply();

  const onChange = () => apply();
  document.addEventListener(deviceSettingEvent('show_stage'), onChange); // same tab (settings page)
  window.addEventListener('storage', onChange);                          // changed in another tab

  return () => {
    document.removeEventListener(deviceSettingEvent('show_stage'), onChange);
    window.removeEventListener('storage', onChange);
  };
});

// Bind a settings-page switch to localStorage. Markup:
//   <input type="checkbox" data-device-setting="show_stage" data-default="true">
// The control reflects the stored value (or the default) and writes back on change, dispatching a
// same-tab event so live appliers (e.g. the env-banner above) update without a reload.
up.compiler('[data-device-setting]', (input) => {
  const key = input.getAttribute('data-device-setting');
  const fallback = input.getAttribute('data-default') === 'true';
  input.checked = getDeviceSetting(key, fallback) !== false;

  const onChange = () => {
    setDeviceSetting(key, input.checked);
    document.dispatchEvent(new CustomEvent(deviceSettingEvent(key)));
  };
  input.addEventListener('change', onChange);

  return () => input.removeEventListener('change', onChange);
});
